import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../Images/Plus credit logo.jpg";

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () => setMenuOpen(!menuOpen);

    return (
        <header>
            <nav className="navbar-container">
                {/* Logo */}
                <div className="logo-container">
                    <img src={logo} alt="logo of plus credit" className="image" />
                </div>

                {/* Toggle Button */}
                <div className="menu-toggle" onClick={toggleMenu}>
                    <span className="icon">{menuOpen ? "–" : "+"}</span>
                </div>

                {/* Navigation Links */}
                <div className={`navbar ${menuOpen ? "open" : ""}`}>
                    <NavLink to="/" className="navlink">Home</NavLink>
                    <NavLink to="/aboutus" className="navlink">About Us</NavLink>
                    <NavLink to="/products" className="navlink">Products</NavLink>
                    <NavLink to="/affiliate" className="navlink">Affiliate</NavLink>
                    <NavLink to="/contactus" className="navlink">Contact Us</NavLink>
                </div>
            </nav>
        </header>
    );
}
